module.exports = __webpack_public_path__ + "assets/img/2021-midAutumn-1.484c1665.png";